module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/15-10dd78c6bfd04b6ef0fa44b1ac754762.jpg";